import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faFacebook,
  faFacebookF,
  faGoogle,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';

import {
  faCalendarAlt,
  faCalendarCheck,
  faCalendarPlus,
  faCheckCircle,
  faCheckSquare,
  faCircleCheck,
  faCircleQuestion,
  faCopy,
  faEye,
  faFile,
  faFloppyDisk,
  faHeart,
  faPenToSquare,
  faSquare,
  faUserCircle,
  faUser as faUserRegular,
} from '@fortawesome/free-regular-svg-icons';

import {
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faBars,
  faBook,
  faCalendar,
  faCalendarCheck as faCalendarCheckSolid,
  faCalendarDay,
  faCalendarDays,
  faCalendarTimes,
  faCameraRotate,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircleCheck as faCircleCheckSolid,
  faCircleMinus,
  faCirclePlus,
  faClock,
  faCloudArrowDown,
  faCloudArrowUp,
  faCommentDots,
  faCommentSlash,
  faComments,
  faCreditCard,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEllipsis,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEyeSlash,
  faFileInvoiceDollar,
  faGears,
  faGift,
  faGripVertical,
  faHandHoldingDollar,
  faHeart as faHeartSolid,
  faHome,
  faImage,
  faInfoCircle,
  faLocationDot,
  faMessage,
  faMinus,
  faPaperPlane,
  faPhone,
  faPlus,
  faPrint,
  faQrcode,
  faReceipt,
  faRefresh,
  faReply,
  faRotate,
  faSearch,
  faShoppingCart,
  faSignOutAlt,
  faSpinner,
  faSquare as faSquareSolid,
  faStar,
  faStarHalf,
  faTag,
  faTicketAlt,
  faTimes,
  faTrashCan,
  faTrashRestore,
  faUpload,
  faUsd,
  faUser,
  faUserCheck,
  faUserFriends,
  faUserGroup,
  faUserXmark,
  faVideo,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAngleDown,
  faCheck,
  faCheckCircle,
  faStar,
  faBook,
  faCaretDown,
  faCaretUp,
  faStarHalf,
  faSquare,
  faSquareSolid,
  faHome,
  faMessage,
  faCalendarAlt,
  faCloudArrowDown,
  faCloudArrowUp,
  faCalendarTimes,
  faCalendarCheck,
  faCalendarPlus,
  faCalendarDay,
  faTicketAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faTimes,
  faChevronRight,
  faChevronLeft,
  faInfoCircle,
  faUserFriends,
  faUserCircle,
  faUserCheck,
  faSignOutAlt,
  faShoppingCart,
  faLocationDot,
  faCircleCheck,
  faCircleCheckSolid,
  faCheckSquare,
  faPenToSquare,
  faGoogle,
  faVideo,
  faEllipsis,
  faQrcode,
  faCalendarCheckSolid,
  faClock,
  faArrowLeft,
  faCalendar,
  faCalendarDays,
  faBars,
  faAngleUp,
  faUser,
  faUserXmark,
  faCircleQuestion,
  faCameraRotate,
  faPlus,
  faCopy,
  faTrashCan,
  faHeart,
  faHeartSolid,
  faEyeSlash,
  faComments,
  faCommentDots,
  faCommentSlash,
  faTrashRestore,
  faReply,
  faDownLeftAndUpRightToCenter,
  faSearch,
  faUpload,
  faDownload,
  faArrowRight,
  faArrowDown,
  faExternalLinkAlt,
  faArrowRightArrowLeft,
  faUserRegular,
  faEye,
  faPaperPlane,
  faUsd,
  faGears,
  faPhone,
  faEnvelope,
  faFloppyDisk,
  faGripVertical,
  faGift,
  faRotate,
  faRefresh,
  faUserGroup,
  faFacebook,
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
  faImage,
  faSpinner,
  faCirclePlus,
  faCircleMinus,
  faMinus,
  faPlus,
  faPrint,
  faReceipt,
  faFileInvoiceDollar,
  faFile,
  faCreditCard,
  faHandHoldingDollar,
  faTag
);

export default function SetupFontAwesome(app) {
  /**
   * Register our FontAwesome component
   * https://github.com/FortAwesome/vue-fontawesome
   */
  app.component('font-awesome-icon', FontAwesomeIcon);
  app.component('font-awesome-layers', FontAwesomeLayers);

  return app;
}
